import { TypeOrder } from '../../interfaces/Order/TypeOrder'
import { TypeOrderAction } from '../actions/typeOrderActions'
import { GET_TYPE_ORDER_EXITO } from '../types/typeOrderActionsTypes'

export interface TypeOrderState {
  typesOrderState: {
    typesOrder?: TypeOrder[]
    error?: string | undefined
  }
}

const initialState: TypeOrderState = {
  typesOrderState: { typesOrder: [], error: '' }
}

export const typeOrderReducer = (
  state: TypeOrderState = initialState,
  action: TypeOrderAction
): TypeOrderState => {
  if (action.type === GET_TYPE_ORDER_EXITO) {
    return {
      ...state,
      typesOrderState: {
        typesOrder: action.typesOrder,
        error: action.error
      }
    }
  }
  return state
}
